// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Random Game Modal CSS Module
 * Styles for the random game picker modal
 */
.NkYbD01qxh4tkDVnRKD3 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  animation: RUfwGpyCNG9HSUYqmV5b 0.2s ease-out;
}
@keyframes RUfwGpyCNG9HSUYqmV5b {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.Nohvju8Kfi_iYezSpMrk {
  width: min(338px, 90vw);
  max-height: min(687px, 98vh);
  background: var(--rgm-modal-bg, rgba(35, 35, 35, 0.9));
  border: 1px solid var(--rgm-modal-border, #404040);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border-radius: 16px;
  box-shadow: var(--rgm-modal-shadow, 0px 0px 8px 0px #000000cc);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 53px 29px 29px;
  animation: SJFWiqpVIEJ0yZTKvPgL 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@keyframes SJFWiqpVIEJ0yZTKvPgL {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.Q4Om9j4p9G52zJgSMLyt {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 22px;
  height: 22px;
  min-width: unset;
  min-height: unset;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.Q4Om9j4p9G52zJgSMLyt:hover {
  opacity: 0.8;
}
.qfmwU27bLbjZl6dF9Gyg {
  font-size: 30px;
  font-weight: 700;
  color: var(--rgm-title-color, #ffffff);
  text-shadow: var(--rgm-title-shadow, none);
  text-transform: uppercase;
  line-height: 32px;
  margin: 0 0 18px;
  text-align: center;
  min-width: 0;
  max-width: 100%;
}
.qfmwU27bLbjZl6dF9Gyg > div {
  line-height: inherit;
  overflow: visible;
}
.OQ2C54smftKapA_KNMgG {
  font-size: 18px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 23px;
  text-align: center;
  line-height: 22px;
  min-height: var(--rgm-subtitle-min-height, 0);
}
.q5lrF2BwlbCMQysMVgxL {
  width: min(246px, 50vw, 40vh);
  aspect-ratio: 246 / 339;
  /* Design specs: 246px × 339px game card */
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 28px;
  transition: transform 0.1s ease-out;
}
@media (max-height: 650px) {
  .Nohvju8Kfi_iYezSpMrk {
    padding: 23px;
  }
  .Q4Om9j4p9G52zJgSMLyt {
    top: 10px;
    right: 10px;
  }
  .qfmwU27bLbjZl6dF9Gyg {
    font-size: calc(30px * 0.8);
    margin-bottom: 8px;
  }
  .OQ2C54smftKapA_KNMgG {
    margin-bottom: 13px;
  }
  .q5lrF2BwlbCMQysMVgxL {
    margin-bottom: 18px;
  }
}
@media (orientation: landscape) and (max-height: 580px) {
  .Nohvju8Kfi_iYezSpMrk {
    width: min(420px, 77vw);
  }
}
@media (max-height: 430px) {
  .Nohvju8Kfi_iYezSpMrk {
    padding: 29px;
  }
  .q5lrF2BwlbCMQysMVgxL {
    width: min(164px, 35vw, 40vh);
  }
}
@media (max-height: 400px) {
  .Nohvju8Kfi_iYezSpMrk {
    padding: clamp(5px, 2vh, 29px) 29px;
  }
  .qfmwU27bLbjZl6dF9Gyg {
    margin-bottom: 0;
  }
  .OQ2C54smftKapA_KNMgG {
    margin-bottom: clamp(3px, 1vh, 13px);
  }
  .q5lrF2BwlbCMQysMVgxL {
    margin-bottom: clamp(8px, 2vh, 18px);
  }
}
@media (max-height: 300px) {
  .q5lrF2BwlbCMQysMVgxL {
    margin-bottom: 18px;
  }
}
.ZelT68fODwWVscqzAY56 {
  width: 100%;
  height: 100%;
  background: var(--rgm-placeholder-bg, linear-gradient(135deg, #48494b 0%, #3a3b3d 100%));
  opacity: 0.8;
  border: 2px dashed var(--rgm-placeholder-border, #999999);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.oJv9E8HEe2kkQbaDGC2u {
  display: flex;
  gap: 8px;
}
.Vr7nxPoeu8H7RJusmyT2 {
  font-size: 48px;
  font-weight: 700;
  color: var(--rgm-question-color, #ffffff);
  animation: c8XFcClbicrWbXUN5W3C 0.4s ease-in-out infinite;
}
.Vr7nxPoeu8H7RJusmyT2:nth-child(1) {
  animation-delay: 0s;
}
.Vr7nxPoeu8H7RJusmyT2:nth-child(2) {
  animation-delay: 0.1s;
}
.Vr7nxPoeu8H7RJusmyT2:nth-child(3) {
  animation-delay: 0.2s;
}
@keyframes c8XFcClbicrWbXUN5W3C {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.5;
  }
  50% {
    transform: translateY(-12px);
    opacity: 1;
  }
}
.hIMObJJUflDpURNEsYMI {
  padding: 0 4px;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff99;
  text-align: center;
  animation: q0_Xgz82zDJKkrkybwta 0.6s ease-in-out infinite;
}
@keyframes q0_Xgz82zDJKkrkybwta {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.ElkEm368ONWpAW7LahKl {
  width: 100%;
  height: 100%;
  background: #48494b;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.RzzQQxqvqvtfWU_ylnSE {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 8px;
  align-items: center;
}
@media (max-height: 580px) {
  .RzzQQxqvqvtfWU_ylnSE {
    flex-direction: row;
  }
}
.Xfr6N36qvTfbdcMhp9b4 {
  opacity: 0.3;
}
.dGrxK578JraQzSyipa0l,
.gD5LNNOci4c78Lu8o2Sy {
  width: 166px;
  height: 40px;
  min-height: unset;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  border: 1px solid transparent;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.dGrxK578JraQzSyipa0l:hover,
.gD5LNNOci4c78Lu8o2Sy:hover {
  opacity: 0.9;
}
.dGrxK578JraQzSyipa0l:disabled,
.gD5LNNOci4c78Lu8o2Sy:disabled {
  opacity: 1;
  cursor: not-allowed;
  pointer-events: none;
}
.dGrxK578JraQzSyipa0l {
  background: var(--rgm-play-bg, #f9f9f9);
  border: none;
  color: var(--rgm-play-color, #313131);
  text-transform: uppercase;
}
.gD5LNNOci4c78Lu8o2Sy {
  background: var(--rgm-again-bg, #313131);
  border-color: var(--rgm-again-border, rgba(249, 249, 249, 0.5));
  color: var(--rgm-again-color, #d9d9d9);
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/features/search/components/RandomGameModal/RandomGameModal.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6CAA+B;AACjC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,sDAAsD;EACtD,kDAAkD;EAClD,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,8DAA8D;EAC9D,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uEAA0D;AAC5D;AACA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,0CAA0C;EAC1C,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,wFAAwF;EACxF,YAAY;EACZ,yDAAyD;EACzD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,yDAA2C;AAC7C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;;IAEE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yDAA0C;AAC5C;AACA;EACE;;IAEE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,6BAA6B;AAC/B;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,uCAAuC;EACvC,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,wCAAwC;EACxC,+DAA+D;EAC/D,sCAAsC;EACtC,gBAAgB;AAClB","sourcesContent":["/**\n * Random Game Modal CSS Module\n * Styles for the random game picker modal\n */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 200;\n  animation: fadeIn 0.2s ease-out;\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.modal {\n  width: min(338px, 90vw);\n  max-height: min(687px, 98vh);\n  background: var(--rgm-modal-bg, rgba(35, 35, 35, 0.9));\n  border: 1px solid var(--rgm-modal-border, #404040);\n  backdrop-filter: blur(30px);\n  -webkit-backdrop-filter: blur(30px);\n  border-radius: 16px;\n  box-shadow: var(--rgm-modal-shadow, 0px 0px 8px 0px #000000cc);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 53px 29px 29px;\n  animation: scaleIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.closeButton {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  width: 22px;\n  height: 22px;\n  min-width: unset;\n  min-height: unset;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n.closeButton:hover {\n  opacity: 0.8;\n}\n.title {\n  font-size: 30px;\n  font-weight: 700;\n  color: var(--rgm-title-color, #ffffff);\n  text-shadow: var(--rgm-title-shadow, none);\n  text-transform: uppercase;\n  line-height: 32px;\n  margin: 0 0 18px;\n  text-align: center;\n  min-width: 0;\n  max-width: 100%;\n}\n.title > div {\n  line-height: inherit;\n  overflow: visible;\n}\n.subtitle {\n  font-size: 18px;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0 0 23px;\n  text-align: center;\n  line-height: 22px;\n  min-height: var(--rgm-subtitle-min-height, 0);\n}\n.gameCardContainer {\n  width: min(246px, 50vw, 40vh);\n  aspect-ratio: 246 / 339;\n  /* Design specs: 246px × 339px game card */\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  margin-bottom: 28px;\n  transition: transform 0.1s ease-out;\n}\n@media (max-height: 650px) {\n  .modal {\n    padding: 23px;\n  }\n  .closeButton {\n    top: 10px;\n    right: 10px;\n  }\n  .title {\n    font-size: calc(30px * 0.8);\n    margin-bottom: 8px;\n  }\n  .subtitle {\n    margin-bottom: 13px;\n  }\n  .gameCardContainer {\n    margin-bottom: 18px;\n  }\n}\n@media (orientation: landscape) and (max-height: 580px) {\n  .modal {\n    width: min(420px, 77vw);\n  }\n}\n@media (max-height: 430px) {\n  .modal {\n    padding: 29px;\n  }\n  .gameCardContainer {\n    width: min(164px, 35vw, 40vh);\n  }\n}\n@media (max-height: 400px) {\n  .modal {\n    padding: clamp(5px, 2vh, 29px) 29px;\n  }\n  .title {\n    margin-bottom: 0;\n  }\n  .subtitle {\n    margin-bottom: clamp(3px, 1vh, 13px);\n  }\n  .gameCardContainer {\n    margin-bottom: clamp(8px, 2vh, 18px);\n  }\n}\n@media (max-height: 300px) {\n  .gameCardContainer {\n    margin-bottom: 18px;\n  }\n}\n.rollingPlaceholder {\n  width: 100%;\n  height: 100%;\n  background: var(--rgm-placeholder-bg, linear-gradient(135deg, #48494b 0%, #3a3b3d 100%));\n  opacity: 0.8;\n  border: 2px dashed var(--rgm-placeholder-border, #999999);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n.questionMarks {\n  display: flex;\n  gap: 8px;\n}\n.questionMark {\n  font-size: 48px;\n  font-weight: 700;\n  color: var(--rgm-question-color, #ffffff);\n  animation: bounce 0.4s ease-in-out infinite;\n}\n.questionMark:nth-child(1) {\n  animation-delay: 0s;\n}\n.questionMark:nth-child(2) {\n  animation-delay: 0.1s;\n}\n.questionMark:nth-child(3) {\n  animation-delay: 0.2s;\n}\n@keyframes bounce {\n  0%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.5;\n  }\n  50% {\n    transform: translateY(-12px);\n    opacity: 1;\n  }\n}\n.rollingText {\n  padding: 0 4px;\n  font-size: 18px;\n  font-weight: 500;\n  color: #ffffff99;\n  text-align: center;\n  animation: pulse 0.6s ease-in-out infinite;\n}\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.gameCardPlaceholder {\n  width: 100%;\n  height: 100%;\n  background: #48494b;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.actions {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  gap: 8px;\n  align-items: center;\n}\n@media (max-height: 580px) {\n  .actions {\n    flex-direction: row;\n  }\n}\n.actionsDisabled {\n  opacity: 0.3;\n}\n.playNowButton,\n.tryAgainButton {\n  width: 166px;\n  height: 40px;\n  min-height: unset;\n  border-radius: 10px;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n.playNowButton:hover,\n.tryAgainButton:hover {\n  opacity: 0.9;\n}\n.playNowButton:disabled,\n.tryAgainButton:disabled {\n  opacity: 1;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.playNowButton {\n  background: var(--rgm-play-bg, #f9f9f9);\n  border: none;\n  color: var(--rgm-play-color, #313131);\n  text-transform: uppercase;\n}\n.tryAgainButton {\n  background: var(--rgm-again-bg, #313131);\n  border-color: var(--rgm-again-border, rgba(249, 249, 249, 0.5));\n  color: var(--rgm-again-color, #d9d9d9);\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `NkYbD01qxh4tkDVnRKD3`,
	"fadeIn": `RUfwGpyCNG9HSUYqmV5b`,
	"modal": `Nohvju8Kfi_iYezSpMrk`,
	"scaleIn": `SJFWiqpVIEJ0yZTKvPgL`,
	"closeButton": `Q4Om9j4p9G52zJgSMLyt`,
	"title": `qfmwU27bLbjZl6dF9Gyg`,
	"subtitle": `OQ2C54smftKapA_KNMgG`,
	"gameCardContainer": `q5lrF2BwlbCMQysMVgxL`,
	"rollingPlaceholder": `ZelT68fODwWVscqzAY56`,
	"questionMarks": `oJv9E8HEe2kkQbaDGC2u`,
	"questionMark": `Vr7nxPoeu8H7RJusmyT2`,
	"bounce": `c8XFcClbicrWbXUN5W3C`,
	"rollingText": `hIMObJJUflDpURNEsYMI`,
	"pulse": `q0_Xgz82zDJKkrkybwta`,
	"gameCardPlaceholder": `ElkEm368ONWpAW7LahKl`,
	"actions": `RzzQQxqvqvtfWU_ylnSE`,
	"actionsDisabled": `Xfr6N36qvTfbdcMhp9b4`,
	"playNowButton": `dGrxK578JraQzSyipa0l`,
	"tryAgainButton": `gD5LNNOci4c78Lu8o2Sy`
};
export default ___CSS_LOADER_EXPORT___;
